import { render, staticRenderFns } from "./QueenCycles.vue?vue&type=template&id=d128ab48&scoped=true&"
import script from "./QueenCycles.vue?vue&type=script&lang=js&"
export * from "./QueenCycles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d128ab48",
  null
  
)

export default component.exports